// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"NextGenInfo_TheComp___bigC"};